import { ToolbarCompass } from "@circle-react-uikit/TipTapBlockEditor/Toolbar/ToolbarCompass";
import type { ToolbarButton } from "@circle-react-uikit/TipTapBlockEditor/Toolbar/types";
import type { ComponentPropsWithoutRef } from "react";

type ToolbarCompassProps = ComponentPropsWithoutRef<typeof ToolbarCompass>;

const COMPACT_HIDDEN_BUTTONS: ToolbarButton[] = ["file", "gif"];

export const CompactToolbar = (props: ToolbarCompassProps) => (
  <ToolbarCompass {...props} hiddenButtons={COMPACT_HIDDEN_BUTTONS} />
);
